import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompositeListingComponent } from '../composite-listing/composite-listing.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { CompositeListingService } from '../composite-listing.service';
import { CompositeListing } from '../composite-listing';
import { PropertyService } from '@app/_components/property/property.service';

@Component({
    selector: 'app-composite-listing-list',
    templateUrl: './composite-listing-list.component.html',
    styleUrls: ['./composite-listing-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class CompositeListingListComponent implements OnInit {
	properties: any;
	sitePriorities: any;
	constructor(
		private compositeListingService: CompositeListingService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private propertyService: PropertyService,
		private dialog: MatDialog,
	) {
		this.statuses = compositeListingService.statuses;
		this.sitePriorities = compositeListingService.sitePriorities;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() shortTermRentalId: any;
	// Hotel Room V2: 2 = composite, 3 = hotel room. Forwarded to the add/edit dialog so
	// it can reject non-STR children for hotel rooms (children must be listingType = 1).
	@Input() parentListingType: number | null = null;
	compositeListings: any;
	compositeListing: CompositeListing;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'compositeListingId', header: 'Id', width: 'auto' },
		{ field: 'compositeShortTermRentalId', header: 'Composite Property Code', width: 'auto' },
		{ field: 'shortTermRentalId', header: 'Property Code', width: 'auto' },
		{ field: 'listingPriority', header: 'Listing Priority', width: 'auto' },
	];

	ngOnInit(): void {
		this.fetchProperties();
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.propertySummaryForShortData()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;

							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.compositeListingId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-compositeListing-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.shortTermRentalId)
				{
					// show only activities that are assigned to this activityId
					let shortTermRentalIdFilter = { 'compositeShortTermRentalId': { 'value': this.shortTermRentalId, 'matchMode': 'in' } };
					Object.assign(event.filters, shortTermRentalIdFilter);
				}
			const pageNumber = Math.round(event.first / event.rows);
			this.compositeListingService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.compositeListings = res.data.compositeListings;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.compositeListings = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		if(this.shortTermRentalId){
			console.log('onRowSelect: ' + JSON.stringify(event));
			this.onOpenFormEdit(event.data);
		}
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(compositeListing: CompositeListing) {
		try {
			this.formLoading = true;
			this.compositeListingService.update(compositeListing)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.compositeListings.map((compositeListing, i) => {
							if (compositeListing.compositeListingId === res.data.compositeListing.compositeListingId) {
								this.compositeListings[i] = res.data.compositeListing;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(compositeListing: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(compositeListing));

			this.formLoading = true;
			this.compositeListingService.delete(compositeListing.compositeListingId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.compositeListings.splice(this.compositeListings.indexOf(compositeListing), 1);
						this.recordTotal = this.compositeListings.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'CompositeListing ' + compositeListing.compositeListingId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'CompositeListing ' + compositeListing.compositeListingId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: this.parentListingType == 3 ? 'Add Hotel Room Child' : 'Add CompositeListing',
			compositeShortTermRentalId: this.shortTermRentalId,
			parentListingType: this.parentListingType
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CompositeListingComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addCompositeListingCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(compositeListing: CompositeListing) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			compositeListing: compositeListing,
			title: this.parentListingType == 3 ? 'Edit Hotel Room Child' : 'Edit CompositeListing',
			parentListingType: this.parentListingType
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CompositeListingComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateCompositeListingCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteCompositeListingCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addCompositeListingCB(compositeListing: CompositeListing) {
		console.log('Adding CompositeListing: ' + JSON.stringify(compositeListing));
		// if we don't have a compositeListings array yet...
		if (!this.compositeListings) {
			this.compositeListings = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.compositeListings.unshift(compositeListing);

		// no idea what this is but it is required to update the array
		this.compositeListings = [...this.compositeListings];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CompositeListing ' + compositeListing.compositeListingId + ' Added', life: 3000 });
	}

	updateCompositeListingCB(compositeListing: CompositeListing) {
		console.log('Updating CompositeListing: ' + JSON.stringify(compositeListing));
		let itemIndex = this.compositeListings.findIndex((item: any) => item.compositeListingId === compositeListing.compositeListingId);
		this.compositeListings[itemIndex] = compositeListing;

		// no idea what this is but it is required to update the array
		this.compositeListings = [...this.compositeListings];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CompositeListing ' + compositeListing.compositeListingId + ' Updated', life: 3000 });
	}

	deleteCompositeListingCB(compositeListing: CompositeListing) {
		console.log('Removing CompositeListing: ' + compositeListing);
		this.compositeListings.splice(this.compositeListings.indexOf(compositeListing), 1);
		this.recordTotal = this.compositeListings.length;

		// no idea what this is but it is required to update the array
		this.compositeListings = [...this.compositeListings];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CompositeListing ' + compositeListing.compositeListingId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.compositeListings ? this.first === (this.compositeListings.length - this.rows) : true; }
	isFirstPage(): boolean { return this.compositeListings ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getPropertyCode(shortTermRentalId: any) {
		if (shortTermRentalId) {
			const status = this.properties.find((e: any) => e.shortTermRentalId == shortTermRentalId);
			return status.propertyCode;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
